import {httpCreateEvent, HttpCreateEventOptions} from '@/features/agenda/http/agenda.http'
import {EventSmall} from '@/features/agenda/types'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {FormErrorResponse} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

export const useStoreEvent = (
    options: Omit<
        UseMutationOptions<EventSmall[], AxiosError<FormErrorResponse>, HttpCreateEventOptions['payload']>,
        'mutationFn'
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_EVENT],
        mutationFn: payload => httpCreateEvent({payload}),
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PLANNED_ACCESSES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT_ACCESS_COUNTERS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_AVAILABILITIES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS, 'extended']})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.TREATMENT_REQUESTS_GROUPS]})

            for (const patient of variables.eventPatients) {
                void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, patient.projectId]})
            }

            options?.onSuccess?.(data, variables, context)
        }
    })
}
